import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import AdminLoginModal from "@/components/feature/AdminLoginModal";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AdminAuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AdminLoginModal />
          <AppRoutes />
        </BrowserRouter>
      </AdminAuthProvider>
    </I18nextProvider>
  );
}

export default App;
